import { AssetResolverBase } from './asset.resolver.base';
import { AssetService } from './asset.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class AssetResolver extends AssetResolverBase {

  constructor(protected service: AssetService) {
    super(service);
  }
}



